var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFacilityOther = function SvgFacilityOther(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 48,
    viewBox: "0 -960 960 960",
    width: 48
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M160-120v-480l320-240 320 240v480H160Zm60-60h310v-145H220v145Zm370 0h150v-145H590v145ZM220-385h150v-145H220v145Zm210 0h310v-145H430v145ZM247-590h466L480-763 247-590Z"
  })));
};
export default SvgFacilityOther;